import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'
import { colors } from 'src/theme'

export interface ContractorStepDetailsReviewButtonProps {
  onAction: () => void | Promise<void>
  label?: string
  disabled?: boolean
  loading?: boolean
  className?: string
  iconOnly?: boolean
  showReviewButtonWithText?: boolean
  showDocumentIcon?: boolean
}

const ContractorStepDetailsReviewButtonComponent = ({
  onAction,
  iconOnly,
  showReviewButtonWithText = false,
  showDocumentIcon = false,
  className,
  ...rest
}: ContractorStepDetailsReviewButtonProps) => {
  if (iconOnly) {
    return (
      <Button
        onClick={onAction}
        size="small"
        color="white"
        iconOnly
        rightIcon={
          <GSIcon
            iconName={showDocumentIcon ? 'gs_file_bend' : 'gs_eye_open'}
            width={20}
            height={20}
          />
        }
        className={className}
        {...rest}
      />
    )
  }

  return (
    <Button
      onClick={onAction}
      fullWidth={showReviewButtonWithText}
      size="small"
      color={showReviewButtonWithText ? 'light' : 'white'}
      cardAction
      className={className}
      rightIcon={
        <span css={[tw`inline-flex`, { '& path': { fill: colors.PRIMARY_PURPLE_500 } }]}>
          <GSIcon iconName="gs_eye_open" width={20} height={20} />
        </span>
      }
      {...rest}
    >
      {showReviewButtonWithText ? 'Review' : undefined}
    </Button>
  )
}

export const ContractorStepDetailsReviewButton = memo(ContractorStepDetailsReviewButtonComponent)
